import { WeekdayIndexMap, Weekdays } from '../enum';

export const getNumericalWeekdayRepresentation = (
  weekday: Weekdays
): number => {
  return WeekdayIndexMap.get(weekday);
};
